import type { Language } from '../content/content';
import { content } from '../content/content';
import { getSurveyUrl } from '../config/externalLinks';

type SurveyButtonProps = {
  language: Language;
  className?: string;
};

export function SurveyButton({ language, className = 'primaryButton' }: SurveyButtonProps) {
  const copy = content[language];
  const surveyUrl = getSurveyUrl(language);

  if (!surveyUrl) {
    return (
      <p className="inlineNotice" role="status">
        {language === 'es'
          ? 'La encuesta aún no tiene URL configurada.'
          : 'The survey URL is not configured yet.'}
      </p>
    );
  }

  return (
    <a className={className} href={surveyUrl} target="_blank" rel="noreferrer">
      {copy.surveyCta}
    </a>
  );
}
